export var ObjectStoreCredentialsKind;
(function (ObjectStoreCredentialsKind) {
    ObjectStoreCredentialsKind["IAM"] = "Iam";
    ObjectStoreCredentialsKind["SERVER_STS"] = "ServerSts";
    ObjectStoreCredentialsKind["CLIENT_STS"] = "ClientSts";
})(ObjectStoreCredentialsKind || (ObjectStoreCredentialsKind = {}));
// NOTE the underlying values are persisted
export var StorageClass;
(function (StorageClass) {
    StorageClass["STANDARD"] = "standard";
    StorageClass["INTELLIGENT_TIERING"] = "intelligentTiering";
})(StorageClass || (StorageClass = {}));
export var ObjectStoreType;
(function (ObjectStoreType) {
    ObjectStoreType["S3"] = "s3";
    ObjectStoreType["AZURE"] = "azure";
})(ObjectStoreType || (ObjectStoreType = {}));
